import { HomeScreen } from '../constants/HomeScreen';
import { HOME_URL, HOME_WIDGETS, RESELLER, SIGNACADEMY } from '../config/routes';

export const getHomeScreenUrl = (userHomeScreen: HomeScreen | null | undefined): string => {
    if (!userHomeScreen) {
        return HOME_URL;
    }
    const mapHomeScreenToUrl = {
        [HomeScreen.Dashboard]: HOME_URL,
        [HomeScreen.HomeWidgets]: HOME_WIDGETS,
        [HomeScreen.Signacademy]: SIGNACADEMY,
        [HomeScreen.Reseller]: RESELLER,
    };
    return mapHomeScreenToUrl[userHomeScreen];
};
